import { computed } from "@preact/signals-react"
import {
	acriss,
	analyzerDate,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	offices,
	officesPickoff,
	prepaid,
	priceKpi,
	providers,
	reports,
	searchID,
	sites,
	transmission,
	webSuppliers
} from "@signals"
import { SEARCH_GROUP_BY } from "@constants"
import { tableTabSelected } from "Pages/AnalyzersV2/@signals"

export const dorPayload = computed(() => ({
	reportExecutionID: reports.value,
	tabKey: tableTabSelected.value,
	getDiffPriceChar: true,
	acriss: acriss.value,
	automatic: transmission.value,
	categoryID: categories.value,
	fuelPolicyID: fuelPolicy.value,
	providerID: providers.value,
	webSupplierID: webSuppliers.value,
	is_prepaid: prepaid.value,
	unlimited_km: mileage.value,
	groupBy: SEARCH_GROUP_BY.DAY,
	isDailyPrice: priceKpi.value,
	inTerminal: inTerminal.value,
	insurance: insurance.value,
	groupBySiteProvider: includeProviders.value,
	siteID: sites.value,
	currency: currency.value,
	siteMainID: mainSite.value,
	providerMainID: mainProvider.value,
	isNewVersion: true,
	searchID: searchID.value,
	officePickupID: !searchID.value ? offices.value : null,
	officeDropoffID: officesPickoff.value,
	lor: lengthRental.value,
	pickupDate: analyzerDate.value,
	reportType: 'dor',
}))